import { useMutation } from '@tanstack/react-query';

import { getBookingEndpoint } from 'reservations/base/constants/endpoints';
import { useModal } from 'reservations/base/providers/ModalProvider';
import { useBookingId } from 'reservations/booking/providers/BookingProvider';
import {
  type BookingMutationResponse,
  BookingMutationResponseSchema
} from 'reservations/booking/types';
import { restClient } from 'utility/restClient';
import type { RequestError } from 'utility/restClient';

export const useConfirmBookingMutationV2 = () => {
  const bookingId = useBookingId();
  const { close } = useModal();

  return useMutation<BookingMutationResponse, RequestError>({
    mutationKey: ['CONFIRM_BOOKING'],
    mutationFn: async () => {
      const endpoint = getBookingEndpoint(bookingId, 'confirm');
      const response = await restClient.put(endpoint);

      try {
        return BookingMutationResponseSchema.parse(response);
      } catch (err) {
        console.error('useConfirmBookingMutationV2: ', err);
        throw err;
      }
    },
    onSuccess: _data => {
      close();
    }
  });
};
